import { connect } from 'react-redux';

import { FavoriteEntityControlsBar } from '../../components/FavoriteEntityControlsBar';
import { selectIsPrinting, selectOptions } from '../../selectors/print';
import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
function mapStateToProps(state: IApplicationState) {
  const printOptions = selectOptions(state);

  return {
    page: state.page,
    favoriteEntities: state.results.favoriteEntities,
    user: state.user,
    total: state.results.total,
    printPhoneNumbers: printOptions.printPhoneNumbers,
    isPrinting: selectIsPrinting(state),
  };
}

export const FavoriteEntityControlsBarContainer = connect(mapStateToProps)(FavoriteEntityControlsBar);
